import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { AppSettings } from '../../app.settings';

/**
 * Runtime language selector. Persists the choice to localStorage
 * (AppSettings.APP_LANG) and restores it on load. SSR-safe.
 */
@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslocoModule],
  template: `
    <select class="form-select form-select-sm language-switcher"
            [ngModel]="active" (ngModelChange)="change($event)"
            [attr.aria-label]="'common.language' | transloco">
      @for (l of langs; track l.code) {
        <option [value]="l.code">{{ l.label }}</option>
      }
    </select>
  `,
  styles: [`.language-switcher{width:auto;display:inline-block;min-width:8rem}`]
})
export class LanguageSwitcherComponent implements OnInit {
  private transloco = inject(TranslocoService);
  private platformId = inject(PLATFORM_ID);

  readonly langs = [
    { code: 'en', label: 'English' },
    { code: 'fr', label: 'Français' },
    { code: 'de', label: 'Deutsch' },
    { code: 'es', label: 'Español' },
  ];
  active = this.transloco.getActiveLang();

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const saved = localStorage.getItem(AppSettings.APP_LANG);
      if (saved && this.langs.some(l => l.code === saved)) {
        this.transloco.setActiveLang(saved);
        this.active = saved;
      }
    }
  }

  change(code: string): void {
    this.transloco.setActiveLang(code);
    this.active = code;
    if (isPlatformBrowser(this.platformId)) {
      try { localStorage.setItem(AppSettings.APP_LANG, code); } catch { /* ignore */ }
    }
  }
}
